

// src/redux/cardsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, nannyNotificationApi } from '../../utils/Constants';

// Async thunk for fetching data
export const nannyNotificationList = createAsyncThunk('NannyNotificationList', async (payload) => {
    const token = localStorage.getItem("Token")
    const headers = {
        "Authorization": token, "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
    }
    try {
        const url = BASE_URL + nannyNotificationApi + "?limit=100&skip=0"
        const response = await axios.get(url, { headers }); // Replace with your API endpoint
        return response.data;
    } catch (error) {
        throw error;
    }
});

const NannyNotificationSlice = createSlice({
    name: 'nannyNotificationReducer',
    initialState: {
        data: null,
        loading: 'idle',
        error: null,
    },
    reducers: {
        clearData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(nannyNotificationList.pending, (state) => {
                state.loading = 'pending';
            })
            .addCase(nannyNotificationList.fulfilled, (state, action) => {
                state.loading = 'idle';
                state.data = action.payload;
                state.error = null;
            })
            .addCase(nannyNotificationList.rejected, (state, action) => {
                state.loading = 'idle';
                state.error = action.error.message;
            });
    },
});

export const { clearData } = NannyNotificationSlice.actions

export default NannyNotificationSlice.reducer;
